import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import Vue3CountryIntl from 'vue3-country-intl'
import 'vue3-country-intl/lib/vue3-country-intl.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

// 导入API
import api from './api'
// 导入请求实例
import request from './utils/request'

const app = createApp(App)

app.use(router)
app.use(i18n)
app.use(ElementPlus, {
  locale: zhCn,
})
app.component(Vue3CountryIntl.name, Vue3CountryIntl)

// 将API和请求实例挂载到全局
app.config.globalProperties.$api = api
app.config.globalProperties.$http = request

app.mount('#app')
